import { render, staticRenderFns } from "./carTempStatic.vue?vue&type=template&id=1f9618c7&"
import script from "./carTempStatic.vue?vue&type=script&lang=js&"
export * from "./carTempStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports